import { createStyles, makeStyles, Toolbar } from "@material-ui/core";
import {
    AreaNotificationMessage,
    Button,
    DesktopPage,
    DesktopPageActions,
    DesktopPageSection,
    MarketResearchTool,
    MarketResearchType,
    RelodeTheme,
    Text,
} from "@relode/core";
import * as React from "react";

import { MarketResearchUpSellMarketingSection } from "../../../shared/components";
import { useClientPublicMarketResearchContext } from "./_infra/clientPublicMarketResearchProvider";
import { ClientPublicMarketResearchProps } from "./clientPublicMarketResearchProps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                backgroundColor: "white",
                padding: 16,
            },
        }),
    { name: "MarketResearchDesktop" }
);

export const ClientPublicMarketResearchDesktop = (
    props: ClientPublicMarketResearchProps
) => {
    const classes = useStyles(props);
    const [state] = useClientPublicMarketResearchContext();
    const {
        searchResults,
        searchResults: {
            overview: { error, data: overviewData },
        },
    } = state;

    const { showMarketing, onSignIn } = props;

    if (error) {
        return (
            <DesktopPage
                pageTitle="market research"
                actions={
                    <DesktopPageActions
                        showLogo={true}
                        title="market research failed"
                        pageActions={
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={onSignIn}
                            >
                                sign in
                            </Button>
                        }
                    />
                }
            >
                <div>
                    <AreaNotificationMessage level="error">
                        {error?.friendlyMessages ? (
                            <>{error?.friendlyMessages}</>
                        ) : (
                            <>
                                The information you are looking for cannot be
                                found. Contact support at{" "}
                                <a
                                    href="mailto:support@relode.com"
                                    target="_blank"
                                >
                                    support@relode.com
                                </a>{" "}
                                if you have any questions.
                            </>
                        )}
                    </AreaNotificationMessage>
                </div>
            </DesktopPage>
        );
    }

    return (
        <DesktopPage
            pageTitle="market research"
            data-cy="marketResearch-page"
            actions={
                <DesktopPageActions
                    showLogo={true}
                    title="market research"
                    pageActions={
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={onSignIn}
                        >
                            sign in
                        </Button>
                    }
                />
            }
        >
            <DesktopPageSection label="market research" id="marketResearch">
                <div className={classes.root}>
                    {showMarketing ? (
                        <MarketResearchUpSellMarketingSection
                            jobManagerName={overviewData?.jobManager?.fullName}
                            jobManagerPhoneNumber={
                                overviewData?.jobManager?.phoneNumber
                            }
                            jobManagerEmail={overviewData?.jobManager?.email}
                        />
                    ) : null}
                    <Toolbar disableGutters={true}>
                        <Text variant="h2">summary</Text>
                    </Toolbar>
                    <MarketResearchTool
                        state={searchResults}
                        marketResearchType={MarketResearchType.PublicTool}
                    />
                </div>
            </DesktopPageSection>
        </DesktopPage>
    );
};
